var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotAvailable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#BFC6D6;}\r\n\t.st1{fill:#F40648;}\r\n\t.st2{fill:#1E2F52;}\r\n\t.st3{fill:#FDCAC6;}\r\n\t.st4{fill:#D97871;}\r\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:0.7755;stroke-miterlimit:10;}\r\n\t.st6{opacity:0.51;fill:#1E2F52;}\r\n\t.st7{fill:#FDCAC6;stroke:#FDCAC6;stroke-width:1.4936;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st8{fill:#E09691;stroke:#E09691;stroke-width:1.4936;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st9{fill:#03022B;}\r\n\t.st10{fill:#FFFFFF;}\r\n\t.st11{fill:none;stroke:#1E2F52;stroke-width:1.2651;stroke-miterlimit:10;}\r\n\t.st12{opacity:0.12;fill:#1E2F52;}\r\n\t.st13{fill:#FDBCB7;}\r\n\t.st14{fill:#C12631;}\r\n\t.st15{fill:#F8F4EB;}\r\n\t.st16{fill:none;stroke:#F40648;stroke-width:2.2048;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -121.8623 194.5247)",
    className: "st0",
    cx: 173.9,
    cy: 244.4,
    rx: 88.2,
    ry: 88.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.4,248.7h-17.2L97.1,202l-0.3,0.1v46.6H79.6v-74.2h17.2l27.2,46.6l0.3-0.1v-46.5h17.2V248.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.9,218.3c0,9.1-2.9,16.7-8.7,22.6c-5.8,5.9-13.4,8.9-22.7,8.9c-9.4,0-17-3-22.9-8.9 c-5.8-5.9-8.8-13.5-8.8-22.6v-13.3c0-9.1,2.9-16.6,8.7-22.6c5.8-5.9,13.4-8.9,22.8-8.9c9.3,0,16.9,3,22.7,8.9 c5.8,5.9,8.8,13.5,8.8,22.6V218.3z M197.7,204.8c0-5.3-1.2-9.6-3.7-13c-2.5-3.4-6-5.1-10.6-5.1c-4.7,0-8.2,1.7-10.7,5.1 c-2.5,3.4-3.7,7.7-3.7,13.1v13.5c0,5.4,1.2,9.7,3.7,13.1c2.5,3.4,6.1,5.1,10.7,5.1c4.5,0,8-1.7,10.5-5.1s3.7-7.8,3.7-13.1V204.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.6,187.8H256v60.9h-17.2v-60.9h-19.3v-13.2h56.1V187.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.3,292.4H81.2l-2.5,8.6H67.8l14.4-44.1h5.5v0l0,0h5.5l14.4,44.1H96.9L94.3,292.4z M83.5,284.5h8.4 l-4.1-13.7h-0.2L83.5,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.3,289l0.3,1.6h0.2l0.3-1.5l8.8-32.3h10.7L130.3,301h-11.1L105,256.9h10.7L124.3,289z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.9,292.4h-13.1l-2.5,8.6h-10.8l14.4-44.1h5.5v0l0,0h5.5l14.4,44.1h-10.8L168.9,292.4z M158.2,284.5h8.4 l-4.1-13.7h-0.2L158.2,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M196.3,301h-10.2v-44.1h10.2V301z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.2,293.1h18.9v7.9H204v-44.1h10.2V293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M262.4,292.4h-13.1l-2.5,8.6h-10.8l14.4-44.1h5.5v0l0,0h5.5l14.4,44.1h-10.8L262.4,292.4z M251.6,284.5h8.4 l-4.1-13.7h-0.2L251.6,284.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.9,301v-44.1h14.5c5.5,0,9.7,1,12.8,3c3.1,2,4.6,5.1,4.6,9.1c0,2.1-0.5,4-1.5,5.6 c-1,1.6-2.5,2.9-4.5,3.7c2.6,0.6,4.6,1.7,5.8,3.5c1.3,1.8,1.9,3.8,1.9,6.2c0,4.3-1.4,7.6-4.3,9.8s-7,3.3-12.4,3.3H278.9z  M289.1,275.3h4c2.5,0,4.3-0.4,5.5-1.3c1.2-0.9,1.8-2.1,1.8-3.8c0-1.9-0.6-3.2-1.8-4.1c-1.2-0.9-3-1.3-5.4-1.3h-4.2V275.3z  M289.1,282.1v11.1h6.6c2.2,0,3.8-0.4,4.9-1.3c1.1-0.9,1.6-2.2,1.6-4c0-1.9-0.5-3.3-1.4-4.3c-1-1-2.5-1.5-4.7-1.5h-0.3H289.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.7,293.1h18.9v7.9h-29.2v-44.1h10.2V293.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M379,282.1h-15.6v11h18.6v7.9h-28.9v-44.1h28.9v7.9h-18.7v9.5H379V282.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.1,457.1c0,2.5-23.5,4.6-52.6,4.6c-29,0-52.6-2-52.6-4.6c0-2.5,23.5-4.6,52.6-4.6 C293.6,452.5,317.1,454.5,317.1,457.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.1,457.1c0,2.5-23.5,4.6-52.6,4.6c-29,0-52.6-2-52.6-4.6c0-2.5,23.5-4.6,52.6-4.6 C394.5,452.5,418.1,454.5,418.1,457.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "369.5,432.2 370.3,454.9 416.2,454.5 390.3,443.1 388,431.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "388,431.6 370.3,454.9 369.5,432.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "392.9,442.4 416.2,454.5 370.3,454.9 369.7,443  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.1,
    y: 454.6,
    className: "st1",
    width: 46.6,
    height: 7.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 395.7,
    y1: 444,
    x2: 390.6,
    y2: 447.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 400.2,
    y1: 446.2,
    x2: 395.1,
    y2: 449.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "317.9,430.8 321.1,454.9 275.2,454.5 301.7,442.5 300.6,429.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "300.6,429.4 317.9,430.8 321.1,454.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "298.5,442.4 275.2,454.5 321.1,454.9 319.7,442.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 294.8,
    y1: 444,
    x2: 299.9,
    y2: 447.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 290.4,
    y1: 446.2,
    x2: 295.5,
    y2: 449.3
  })), /*#__PURE__*/React.createElement("rect", {
    x: 274.9,
    y: 454.6,
    className: "st1",
    width: 46.6,
    height: 7.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.4,178l40,4.7c0,0,12.3,4.3,50.8,248.6l-25.6,1.1l-48.6-184.7c-0.7-2.7-4.7-2.1-4.6,0.6l8.9,184.3 l-26.9-2c0,0-32.3-186.2-19.7-215.9C290.2,185,303.4,178,303.4,178z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.2,211.1c0,0,16.1,6.9,25-7.3c8.8-14.2,11.3-22,11.3-22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M332.9,182.7c0,0-1.6,32.3,8,35.5s14.2,2.7,14.2,2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 340.9,
    y1: 218.1,
    x2: 385.8,
    y2: 431.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 289,
    y1: 212.5,
    x2: 308.1,
    y2: 431.3
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M343.4,183.2l-41-4.2c0,0-29.3,26.4-27.1,50.6L343.4,183.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.4,177.9c11.8-50.5-7.1-115.4-7.1-115.4l0,0.1c-0.3-1.4-7.2-15.6-17.3-16.2c-31.7-1.7-107.9,65.9-121.1,75.2 c-1.7,1.2,37,53.9,103.6,56.4C342.9,179,357,179.6,357.4,177.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M345,55.8c-3.5-3.6-10.9-2-15.2-1.3c-11,1.8-21.8,5.5-32.2,9.5c-31.4,11.9-61.4,28.2-88.9,47.5c-1.1,0.7,0,2.5,1,1.7 c26.3-18.4,54.7-34,84.6-45.8c10.3-4.1,20.9-7.8,31.8-10.1c4.1-0.9,13.8-3.7,17.4,0C344.5,58.1,346,56.7,345,55.8L345,55.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M321,78.5c0,0-3.3,25.8-3.6,27.9c0,0,11.2,13.3,22.6,1.9c0,0-1.9-6.3-5.5-22.4L321,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5,84.3c-0.1,3.5-5.1,7.6-8.4,7.6c-4,0.1-7.2-6.3-7.5-9.1c-0.2-2.4,5.9-5.2,9.2-5.1 C332.1,77.8,335.6,80.8,335.5,84.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M313.6,69.7l4.5-0.3l0.4,5.1l-4.5,0.3c-1.4,0.1-2.6-1-2.7-2.4l0,0C311.2,71,312.2,69.8,313.6,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M313.5,71.1l1.9-0.1l0.1,2.1l-1.9,0.1c-0.6,0-1.1-0.4-1.1-1l0,0C312.5,71.6,313,71.1,313.5,71.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M344.5,72.8l-4.5-0.3l0.3-5.1l4.5,0.3c1.4,0.1,2.5,1.3,2.4,2.7l0,0C347.1,71.9,345.9,72.9,344.5,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M344.8,69.2l-1.9-0.1l-0.2,2.1l1.9,0.1c0.6,0,1.1-0.4,1.1-1l0,0C345.8,69.8,345.4,69.3,344.8,69.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M330.7,55.1L330.7,55.1c8.4,0.5,13.5,7.9,13,16.3l0,0.6c-0.5,8.4-7.7,15.5-14.8,15l-0.1,0 c-5.6-0.7-14.8-8.6-14.2-17l0-0.6C315.2,61,322.3,54.6,330.7,55.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M331.8,72.1c0,0.6,0.4,1.1,0.8,1.1c0.5,0,0.8-0.5,0.8-1.1c0-0.6-0.4-1.1-0.8-1.1 C332.1,71,331.8,71.4,331.8,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M325.3,72.1c0,0.6,0.3,1.1,0.8,1.2c0.5,0,0.9-0.4,0.9-1c0-0.6-0.3-1.1-0.8-1.2 C325.7,71,325.3,71.5,325.3,72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M328.2,75.6l2.2,0c0.3,0,0.5-0.3,0.4-0.7l-0.9-2.8c-0.1-0.4-0.5-0.4-0.7,0l-1.3,2.7 C327.7,75.2,327.9,75.6,328.2,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M323.1,69.3c-0.7,0.2,0.7-1.3,1.5-1.3c0.8,0,1.5,0.6,1.5,1.3C326.1,69.3,324.7,68.7,323.1,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M335.5,69.1c0.7,0.2-0.7-1.3-1.5-1.2c-0.8,0-1.5,0.6-1.4,1.4C332.5,69.2,333.8,68.6,335.5,69.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M331.9,79.2c0.5-1.8-1.6-2.7-3.7-2.6c-2.3,0.1-3.7-1.3-4.3,0.9c-0.4,1.4,1.2,3,3.4,3.5 C329.6,81.4,331.6,80.6,331.9,79.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322,55.5c17.6,7.1,22.4,12.6,22.4,12.6s0.8-20-20.7-16.9C309.8,53.2,320.9,55.1,322,55.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.7,54.9c0,0-4.7,9.9-6,11.7c-1.5,2-4.7,0.5-4.7,0.5S311.6,53.2,323.7,54.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M340,108.2l35.1,9.4l6.6,18.7c2.4,6.9-2.7,14.2-10.1,14.2h-17.6c0,0-3.7,24.5-3.7,34l-55.7-7.2l1-39.4 c0,0-34.7,13.7-48.4,11.6c0,0-15.8-9.5-6.8-21.6c0,0,64.5-26.4,74.4-24c0,0,5.7,8.7,14.1,8.7C337.1,112.7,340,108.2,340,108.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M307,103.9c0,0,3.5,12.2,20.6,14.3c16.8,2.1,19.8-8,19.8-8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 294.3,
    y1: 168.2,
    x2: 350.7,
    y2: 174.5
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "295.5,137.9 350.3,184.5 294.5,177.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M365.5,159.9L365.5,159.9c-9.5-1.4-15.5-11-12.4-20.2l6.9-20.5l22.9,3.3l0.1,22.1 C383.1,153.9,374.8,161.2,365.5,159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M359.3,139.4c0,0-14.8-19.5-12.2-20.4c1.7-0.5,6.4,2.1,9.4,4c1.4,0.9,3.2-0.2,3.4-1.9c0.6-5.3,1.8-15,2.3-22 c0.7-10.1,3.5-10.5,5.3,6.7c1.8,17.2,2.8-14.9,5-14.6c2.2,0.3,1.4,18.2,3.2,19.3c1.8,1.1,2.2-17.1,5.8-17.7 c3.6-0.6,0.3,17.7,1.2,18.8c0.9,1.1,3.2-11.7,4.7-11.7c5.3,0.2-4.1,38.7-5.2,41.2c0,0,0,0,0,0c0,0-3.3,5.4-12.8,4.4 C369.5,145.6,363.5,145.6,359.3,139.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M307,124.7L307,124.7c-3.8-0.1-5.3-3.9-5.3-7.7V78.4h13.6V117C315.3,120.7,310.8,124.7,307,124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M304.8,124.9L304.8,124.9c-3.8,0-6.8-3-6.8-6.8V79.5h13.6v38.6C311.6,121.8,308.6,124.9,304.8,124.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M307.2,115c0.3-0.8,10.6-4.4,9.2-6c-1.3-1.7-10.7,3.4-10.7,2.2c0-1.2,9.4-6,8.9-7.2 c-0.5-1.2-17.1,7.5-8.9,1.6c8.3-5.9,7.3-7.2,1.9-4.6c-3.7,1.8-9,4-11.9,5.2c-1,0.4-2-0.2-2-1.2c0.1-2.1,0.1-5.2-0.7-6 c-1.2-1.1-6.9,12-6.9,12s0,0,0,0c-3.5-0.4-24.7,5.7-38.9,11.5c-8.8,3.6-14.3,11.7-9.6,20l0.9,1.5c4.8,8.5,19.3,8.6,26.9,2.6 c11.2-8.9,24.3-20.9,26.4-23.4c0,0,0,0,0,0c1.6-0.1,23.9-6.4,22.5-9.2C314.1,113.3,306.9,115.8,307.2,115z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M303.1,49.2c3.4,2.6,9,8.9,14.1,15c2.2,2.6,4.3,5.2,6.1,7.4c3.5,4.4,4.6,9.8,2.8,14.7l0,0 c-1.5,4.3-5,7.8-9.7,9.8c-1.7,0.7-3.7,1.5-5.8,2.4c-11.6,4.5-28.2,9.6-34,8.7C276.5,107.1,289,38.1,303.1,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M310.6,98.4c2.1-0.8,4.1-1.6,5.8-2.4c4.7-2,8.2-5.5,9.7-9.8l0,0c1.8-4.9,0.7-10.3-2.8-14.7 c-1.8-2.2-3.9-4.8-6.1-7.4C317.2,64.2,329.4,83.7,310.6,98.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M310.3,79.7c-4.3,19.6-22.1,32.6-39.8,29.5c-11.6-1.5-22.9-20.5-18.6-40.1c4.3-19.6,17.1-32.1,34.3-29.5 C303.8,42.8,314.6,60.1,310.3,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M306.9,79.1c-3.8,17.4-19.6,28.9-35.3,26.1c-10.2-1.4-20.3-18.2-16.5-35.6c3.8-17.4,15.1-28.5,30.4-26.2 C301.2,46.4,310.8,61.7,306.9,79.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.1,61.3l24.4,5.1c0,0,4.4,11.9-6.6,26l-23.2-7.1L283.1,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M290.2,75c-1.5,6.8-7.1,11.4-12.5,10.4c-3.9-1-6.9-6.9-5.4-13.7c1.5-6.8,5.5-11.2,10.8-10.4 C288.5,62.3,291.7,68.2,290.2,75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 257.3,
    y1: 31.5,
    x2: 261.5,
    y2: 37.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 268.4,
    y1: 24.7,
    x2: 269.8,
    y2: 35.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 246.5,
    y1: 40.4,
    x2: 256.3,
    y2: 43.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAvailable);
export default __webpack_public_path__ + "static/media/notAvailable.d08866681cf9178eb9332d49e423f386.svg";
export { ForwardRef as ReactComponent };